import { LoginComponent } from './smart-exits/login/login.component';
import { HelloComponent } from './smart-exits/hello/hello.component';
import { OverviewComponent } from './smart-exits/overview/overview.component';
import { PersonalDetailsComponent } from './smart-exits/personal-details/personal-details.component';
import { QuestionsStartComponent } from './smart-exits/questions/questions-start.component';
import { QuestionsComponent } from './smart-exits/questions/questions.component';
import { BenefitsComponent } from './smart-exits/current-benefits/current-benefits.component';
import { SplitPreservationComponent } from './smart-exits/split-preservation/split-preservation.component';
import { PreservationSummaryComponent } from './smart-exits/preservation-summary/preservation-summary.component';
import { RetirementSliderComponent } from './smart-exits/retirement-slider/retirement-slider.component';
import { PreservationOptionsComponent } from './smart-exits/preservation-options/preservation-options.component';
import { MCPFEACQuoteComponent } from './smart-exits/preservation-options/mcpf-eac-quote/mcpf-eac-quote.component';
import { MCPFEACDisclaimerComponent } from './smart-exits/preservation-options/mcpf-eac-disclaimer/mcpf-eac-disclaimer.component';
import { ExternalTransferComponent } from './smart-exits/preservation-options/external-transfer/external-transfer.component';
import { CashOutConfirmComponent } from './smart-exits/cashout-confirm/cashout-confirm.component';
import { BankDetailsComponent } from './smart-exits/bank-details/bank-details.component';
import { UploadDocumentsComponent } from './smart-exits/upload-docs/upload-docs.component';
import { HelpComponent } from './smart-exits/help/help.component';
import { CallMeHelpComponent } from './smart-exits/help/call-me-help/help-info.component';
import { AdviserHelpComponent } from './smart-exits/help/adviser-help/adviser-help.component';
import { AdviserThankYouComponent } from './smart-exits/help/adviser-help/adviser-thank-you.component';
import { ThankYouComponent } from './smart-exits/thank-you/thank-you.component';
import { LogoutComponent } from './smart-exits/logout/logout.component';
import { ErrorComponent } from './smart-exits/error/error.component';
import { ErrorMraDownComponent } from './smart-exits/error-mra-down/error-mra-down.component';
import { OptOutComponent } from './smart-exits/opt-out/opt-out.component';
import { FAWSelfExitComponent } from './smart-exits/faw-self-exit/faw-self-exit.component';
import { FAWExProcessComponent } from './smart-exits/faw-ex-process/faw-ex-process.component';
export var routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'faw-start', component: FAWSelfExitComponent },
    { path: 'exProcess-start', component: FAWExProcessComponent },
    { path: 'hello', component: HelloComponent },
    { path: 'overview', component: OverviewComponent },
    { path: 'details/:edit', component: PersonalDetailsComponent },
    { path: 'before', component: QuestionsStartComponent },
    { path: 'questions', component: QuestionsComponent },
    { path: 'benefits', component: BenefitsComponent },
    { path: 'split-preservation', component: SplitPreservationComponent },
    { path: 'summary', component: PreservationSummaryComponent },
    { path: 'retirement', component: RetirementSliderComponent },
    { path: 'preservation-options', component: PreservationOptionsComponent },
    { path: 'corporate-confirm', component: MCPFEACQuoteComponent },
    { path: 'corporate-disclaimer', component: MCPFEACDisclaimerComponent },
    { path: 'external-transfer', component: ExternalTransferComponent },
    { path: 'cashout-confirm', component: CashOutConfirmComponent },
    { path: 'bank-details', component: BankDetailsComponent },
    { path: 'upload-docs', component: UploadDocumentsComponent },
    { path: 'get-more-help', component: HelpComponent },
    { path: 'help-info', component: CallMeHelpComponent },
    { path: 'help-adviser', component: AdviserHelpComponent },
    { path: 'adviser-thank-you', component: AdviserThankYouComponent },
    { path: 'thank-you', component: ThankYouComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'error', component: ErrorComponent },
    { path: 'error-mra-down', component: ErrorMraDownComponent },
    { path: 'expired', component: ErrorComponent },
    { path: 'unavailable', component: ErrorComponent },
    { path: 'maintenance', component: ErrorComponent },
    { path: 'process_complete', component: ErrorComponent },
    { path: 'opt-out', component: OptOutComponent },
];
// function Configuration($compileProvider, $stateProvider, $urlRouterProvider, $locationProvider) {
//
//   $compileProvider.debugInfoEnabled(false);
//   $locationProvider.hashPrefix('');
//
//   $urlRouterProvider.otherwise('/login');
//
//   $stateProvider.state('login', {
//     url: '/login?e',
//     template: '<login></login>',
//     class: 'login'
//   })
//
//   .state('hello', {
//     url: '^/hello',
//     template: '<hello></hello>'
//   })
//
//   .state('faw-start', {
//     url: '^/faw-start?e',
//     template: '<faw-self-exit></faw-self-exit>'
//   })
//
//   .state('exProcess-start', {
//     url: '^/exProcess-start?e',
//     header: {
//       blurb: 'You have some company benefits through Momentum which you may want to continue with. We would like to know what you want to do with them.'
//     },
//     template: '<faw-ex-process></faw-ex-process>'
//   })
//
//   .state('overview', {
//     url: '^/overview',
//     template: '<overview></overview>'
//   })
//
//   .state('details', {
//     url: '^/details',
//     params: {
//       edit: null
//     },
//     template: '<personal-details></personal-details>'
//   })
//
//   // QUESTION STATES
//   .state('before', {
//     url: '^/before',
//     template: '<questions-start></questions-start>'
//   })
//
//   .state('questions', {
//     url: '^/questions',
//     template: '<questions></questions>'
//   })
//
//   .state('benefits', {
//     url: '^/benefits',
//     template: '<current-benefits></current-benefits>'
//   })
//
//   .state('split-preservation', {
//     url: '^/preservation',
//     template: '<split-preservation></split-preservation>'
//   })
//
//   .state('summary', {
//     url: '^/summary',
//     template: '<preservation-summary></preservation-summary>'
//   })
//
//   .state('retirement', {
//     url: '^/retirement',
//     template: '<retirement-slider></retirement-slider>'
//   })
//
//   // SAVE STATES
//   .state('preservation-options', {
//     url: '^/preservation-options',
//     template: '<preservation-options></preservation-options>'
//   })
//
//   .state('corporate-confirm', {
//     url: '^/confirm',
//     template: '<mcpf-eac-quote></mcpf-eac-quote>'
//   })
//
//   .state('corporate-disclaimer', {
//     url: '^/disclaimer',
//     template: '<mcpf-eac-disclaimer></mcpf-eac-disclaimer>'
//   })
//
//   .state('external-transfer', {
//     url: '^/transfer',
//     template: '<external-transfer></external-transfer>'
//   })
//
//   // CASHOUT STATES
//   .state('cashout-confirm', {
//     url: '^/cashout-confirm',
//     template: '<cash-out-confirm></cash-out-confirm>'
//   })
//
//   .state('bank-details', {
//     url: '^/bank-details',
//     template: '<bank-details></bank-details>'
//   })
//
//   .state('upload-docs', {
//     url: '^/final-step',
//     template: '<upload-documents></upload-documents>'
//   })
//
//   // HELP ME STATES
//   .state('get-more-help', {
//     url: '^/get-more-help',
//     params: {
//       help: null
//     },
//     template: '<help></help>'
//   })
//
//   .state('help-adviser', {
//     url: '^/help-adviser',
//     template: '<adviser-help>'
//   })
//
//   .state('help-info', {
//     url: '^/help-info',
//     params: {
//       help: null
//     },
//     template: '<call-me-help></call-me-help>'
//   })
//
//   // ADVISER THANK YOU STATE
//   .state('adviser-thank-you', {
//     url: '^/contact-you',
//     template: '<adviser-thank-you></adviser-thank-you>'
//   })
//
//   // END THANK YOU STATE
//   .state('thank-you', {
//     url: '^/thank-you',
//     template: '<thank-you></thank-you>'
//   })
//
//   .state('logout', {
//     url: '^/logout',
//     template: '<logout></logout>'
//   })
//
//   .state('error', {
//     url: '^/error',
//     template: '<error></error>'
//   })
//
//   .state('error-mra-down', {
//     url: '^/error-mra-down',
//     template: '<error-mra-down></error-mra-down>'
//   })
//
//   .state('expired', {
//     url: '^/expired',
//     template: '<error></error>'
//   })
//
//   .state('unavailable', {
//     url: '^/unavailable',
//     template: '<error></error>'
//   })
//
//   .state('maintenance', {
//     url: '^/maintenance',
//     template: '<error></error>'
//   })
//
//   .state('process_complete', {
//     url: '^/process_complete',
//     template: '<error></error>'
//   })
//
//   .state('opt-out', {
//     url: '^/opt-out?e',
//     template: '<opt-out></opt-out>'
//   });
// }
//
// Configuration.$inject = ['$compileProvider', '$stateProvider', '$urlRouterProvider', '$locationProvider'];
//
// angular.module('WLS').config(Configuration);
//# sourceMappingURL=data:application/json;base64,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